
import React from "react";
import { convertAdUrl, translateText } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Translate from "../MultiLanguage/Translate"

const AgeVerifyModal = ({setShowAgeVerifyModal}) => {

 const confirmHandler = () => {
    localStorage.setItem("ageVerified", "true");
    setShowAgeVerifyModal(false);
  };

  return (
    <div className="ageVerifyContainer">
      <div className="overlayModal"></div>
      <div className="contents">
        <div className="ageVerifyModal">
          <div className="ageVerifyMessage">
            <h1> <Translate textKey={'age_verification_title'} /></h1>
            <p>
              <h3><Translate textKey={'age_verification_message_one'} /></h3>
              <h3><Translate textKey={'age_verification_message_two'} /></h3>
            </p>
          </div>

          <div className="buttons">
            <div
              className="buttonContainer"
              onClick={confirmHandler}
            >
              <div className="background"></div>
              <button><Translate textKey={'yes'} /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeVerifyModal;


